import sql from "../../images/icons8-mysql-logo-50.jpg";
const Skills = () => {
  return (
    <div className="d-flex gap-3 mt-4  flex-wrap justify-content-center align-items-center">
      <i
        className=" fs-1 fa-brands fa-html5"
        style={{ color: "#5f9cff" }}
      ></i>
      <i
        style={{ color: "#5f9cff" }}
        className=" fs-1 fa-brands fa-css3-alt"
      ></i>
      <i
        style={{ color: "#5f9cff" }}
        className=" fs-1 fa-brands fa-js"
      ></i>
      <i
        style={{ color: "#5f9cff" }}
        className=" fs-1 fa-brands fa-bootstrap"
      ></i>

      <i
        style={{ color: "#5f9cff" }}
        className=" fs-1 fa-brands fa-sass"
      ></i>

      <i
        style={{ color: "#5f9cff" }}
        className=" fs-1 fa-brands fa-react"
      ></i>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <rect
          width="36"
          height="36"
          x="6"
          y="6"
          fill="#5f9cff"
        ></rect>
        <polygon
          fill="#fff"
          points="27.49,22 14.227,22 14.227,25.264 18.984,25.264 18.984,40 22.753,40 22.753,25.264 27.49,25.264"
        ></polygon>
        <path
          fill="#fff"
          d="M39.194,26.084c0,0-1.787-1.192-3.807-1.192s-2.747,0.96-2.747,1.986 c0,2.648,7.381,2.383,7.381,7.712c0,8.209-11.254,4.568-11.254,4.568V35.22c0,0,2.152,1.622,4.733,1.622s2.483-1.688,2.483-1.92 c0-2.449-7.315-2.449-7.315-7.878c0-7.381,10.658-4.469,10.658-4.469L39.194,26.084z"
        ></path>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <polygon
          fill="#eceff1"
          points="24,4 7,14 7,34 24,44 41,34 41,14"
        ></polygon>
        <polygon
          fill="#0277bd"
          points="23.5,24.5 23.5,33.5 15,29 15,19.5"
        ></polygon>
        <polygon
          fill="#0277bd"
          points="24.5,24.5 24.5,33.5 33,29 33,19.5"
        ></polygon>
        <polygon
          fill="#0277bd"
          points="24,23.5 15.5,18.5 24,14 32.5,18.5"
        ></polygon>
        <g>
          <polygon
            fill="#5f9cff"
            points="23.5,7 23.5,13 14.5,18 9.5,15"
          ></polygon>
          <polygon
            fill="#5f9cff"
            points="23.5,41 23.5,35 14.5,30 9.5,33"
          ></polygon>
          <polygon
            fill="#5f9cff"
            points="14,19 9,16 9,32 14,29"
          ></polygon>
          <polygon
            fill="#5f9cff"
            points="24.5,7 24.5,13 33.5,18 38.5,15"
          ></polygon>
          <polygon
            fill="#5f9cff"
            points="24.5,41 24.5,35 33.5,30 38.5,33"
          ></polygon>
          <polygon
            fill="#5f9cff"
            points="34,19 39,16 39,32 34,29"
          ></polygon>
        </g>
      </svg>

      <i
        style={{ color: "#5f9cff" }}
        class="fs-1 fa-brands fa-node"
      ></i>
      <img src={sql} />
      <i
        style={{ color: "#5f9cff" }}
        className="fs-1 fa-brands fa-aws"
      ></i>
    </div>
  );
};

export default Skills;
